module.exports = __webpack_public_path__ + "static/accedo-logo-deddebf54d586a11569009d3f1b0e088.png";